export const getStorage = (key) => {
    const urlParams = new URLSearchParams(window.location.search);
    const queryToken = urlParams.get(`${key}`);

    return queryToken || localStorage.getItem(`${key}`) || "";
}


